// extracted by mini-css-extract-plugin
module.exports =  {"error":"SSmm_gysqeCdsK2LXSYx","links":"nPSCnviSsH0oo_zJmQdV","list":"YuzEZnwbc7meUgcE8CzQ","bottomMargin":"v6cs3tNpEqQeV5kDsg_e","chipFix":"YSeMi8beb2YrnRWyP3mW"};